module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-600italic.woff2?ebdfa24cb411ba3016abd1c3ea5746e5";